module.exports = {"610124001":"二曲街道","610124101":"哑柏镇","610124102":"终南镇","610124103":"马召镇","610124104":"集贤镇","610124105":"楼观镇","610124106":"尚村镇","610124107":"广济镇","610124108":"厚畛子镇","610124109":"青化镇","610124110":"竹峪镇","610124111":"翠峰镇","610124112":"四屯镇","610124115":"司竹镇","610124116":"九峰镇","610124117":"富仁镇","610124118":"骆峪镇","610124119":"陈河镇","610124120":"板房子镇","610124121":"王家河镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/610124.json
// module id = 2580
// module chunks = 0